import moment from 'moment';
import 'moment/locale/de-at.js';

moment.updateLocale('de-at', {
	invalidDate: 'Ungültiges Datum',
	monthsShort: 'Jän_Feb_Mär_Apr_Mai_Jun_Jul_Aug_Sep_Okt_Nov_Dez'.split('_'),
});

moment.locale('de-at');

window.sis = {
	...window.sis,
	moment: moment
};